module.exports = __webpack_public_path__ + "static/media/proxy.bb729480.png";